<template>
  <div class="header">
    <Logo></Logo>
    <div class="layout-right">
      <ul class="layout-right">
        <li
          class="link"
          :class="{
            highlight:
              item.value === $route.name ||
              (item.child && item.child.includes($route.name)),
          }"
          v-for="item in tabBar"
          :key="item.value"
        >
          <router-link :to="{ name: item.value }">{{ item.name }}</router-link>
        </li>
      </ul>
      <div
        class="route-wrap"
        @mouseenter="handleshowroute"
        @mouseleave="handlecloseroute"
      >
        Dataset Service
        <div class="route-show" v-show="showroute">
          <div class="tip-trangle-top"></div>
          <span>
            <router-link :to="{ name: 'findmore' }"
              >Dataset Discovery</router-link
            >
          </span>
          <hr class="horizontal-rule" />
          <span>
            <router-link :to="{ name: 'recommend' }"
              >Dataset Recommendation</router-link
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "../Logo";
export default {
  components: {
    Logo,
  },
  data() {
    return {
      // 隐藏logo的route name
      logoHiddenRoutes: ["home"],
      // dark模式的route name
      darkStyleRoutes: ["home"],
      // 跳转至外部的route name
      alinkRoutes: ["about", "github", "endpoint"],
      showroute: false,
      tabBar: [
        {
          value: "home",
          name: "Home",
        },
        // {
        //     value: 'recommend',
        //     name: 'Data Recommendation'
        // },
      ],
    };
  },
  methods: {
    handleshowroute() {
      this.showroute = true;
    },
    handlecloseroute() {
      this.showroute = false;
    },
  },
};
</script>
<style lang="less" scoped>
* {
  font-family: ddefont;
}
.header {
  height: 45px;
  background: linear-gradient(116.69deg, #000 -86.16%, #00a2ff 56.2%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
  color: #fff;
  z-index: 999;
  width: 100%;
  // overflow: hidden;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);

  .layout-right {
    display: flex;
    align-items: center;
    margin-right: 4px;
    line-height: 64px;
  }
  .title {
    font-family: Source Han Sans SC;
    font-weight: 900;
    font-size: 28px;
    margin-left: 16px;
    vertical-align: bottom;
  }
  .link {
    font-size: 12px;
    margin-left: 36px;
    cursor: pointer;
    line-height: 36px;
  }
  .highlight {
    font-weight: 900;
    border-bottom: 2px solid white;
  }
  .hidden-logo {
    visibility: hidden;
  }
  .link a,
  .router-link-active {
    color: inherit;
    text-decoration: none;
  }
}
.dark-style {
  color: #000;
  background: transparent;
}
.header-main {
  position: absolute;
  top: 15px;
  left: 0;
  width: 100%;
}
.route-wrap {
  font-family: Source Han Sans SC;
  font-size: 12px;
  margin-left: 16px;
  vertical-align: bottom;
  cursor: pointer;
  position: relative;
  z-index: 1500;
}
#rs {
  span {
    display: block;
    line-height: 30px;
    padding: 0 10px;
    a {
      font-size: 12px !important;
      color: black !important;
      text-decoration: none !important;
    }
  }
  span:hover {
    background-color: rgb(135, 183, 246);
    a {
      color: white !important;
    }
  }
}
.tip-trangle-top {
  position: absolute;
  top: -10px;
  left: 120px;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid rgb(91, 155, 213);
}
.route-show {
  position: fixed;
  width: 180px;
  top: 55px;
  right: 5px;
  background-color: rgb(91, 155, 213);
  border-radius: 5px;
  // box-shadow: 1px 1px 1px 3px #e1e1e1;
  // box-shadow: -5px 5px 10px -4px red;
  // box-shadow: 0 2px 12px 0 rgba(245, 241, 241, 0.4);

  padding: 4px 4px;
  color: white;
  font-size: 12px;
  span {
    display: block;
    line-height: 25px;
    // padding: 0 10px;
    a {
      font-size: 12px !important;
      color: white !important;
      text-decoration: none !important;
    }
  }
  span:hover {
    background-color: rgb(135, 183, 246);
    a {
      color: white !important;
    }
  }
}

hr.horizontal-rule {
  margin: 0;
  border: 0;
  height: 1px;
  background: rgb(91, 155, 213);
  background-image: linear-gradient(
    to right,
    rgb(91, 155, 213),
    #eee,
    rgb(91, 155, 213)
  );
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue